export default __webpack_public_path__ + "static/media/HomePage.eff041aa.png";